import React from 'react';
import { formatoDecimal } from '../../../utilities/formatoNumeros';

const TopTipoPublicaciones = ({ tipos, tablaEstilo }) => {
  const tipoArray = tipos?.topTipoPublicacion || tipos;
  return (
    <div className="table-responsive mb-3">
      <table
        className="table table-sm table-hover mb-0"
        style={{ background: tablaEstilo?.fondo, borderRadius: 6, overflow: 'hidden' }}
      >
        <thead className="thead-light">
          <tr style={{ background: tablaEstilo?.header }}>
            <th>Id</th>
            <th>Descripcion</th>
            <th className="text-right">Unidades</th>
            <th className="text-right">Monto Ventas</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(tipoArray) && tipoArray.length > 0 ? (
            tipoArray.map((t, idx) => (
              <tr key={t.idTipo + idx}>
                <td>{t.idTipoPublicacion || '-'}</td>
                <td>{t.descripcion || t.tipo || '-'}</td>
                <td className="text-right">{t.unidadesVendidas || '-'}</td>
                <td className="text-right">{t.montoVentas || t.ventas ? `$${formatoDecimal(`${t.montoVentas || t.ventas}`)}` : '-'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className="text-center text-muted py-3">Sin datos</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default TopTipoPublicaciones;
